module.exports = __webpack_public_path__ + "static/img/RAOK-LR_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-LR_1.png
// module id = 51n9
// module chunks = 0